import { render, staticRenderFns } from "./invitation-dialog.vue?vue&type=template&id=4266194f"
import script from "./invitation-dialog.vue?vue&type=script&lang=js"
export * from "./invitation-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports